import "../../resources/less/Troubadour/Demo.less";

class Demo {}

$(window).on("load", () => {
  new Demo();
});
